import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-mech-log",
	templateUrl: "./mech-log.component.html",
	styleUrls: ["./mech-log.component.scss"]
})
export class MechLogComponent implements OnInit {
	@ViewChild("exceptionModal", { static: true }) public exceptionModal: any;

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	public brand = BrandVars;

	public totalLogs = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageLogs: any[] = undefined;
	public selectedException: any = null;
	public selectedExceptionStack?: string = undefined;
	public selectedExceptionSubStack?: string = undefined;
	public filters: any = {};

	constructor(private modalService: NgbModal, public api: ApiService) { }

	async ngOnInit() {
		this.ResetFilters();
	}

	async updatePage() {
		const result = await this.api.GetAssetSystemLog(this.asset.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage,
			this.filters.remote_ip, this.filters.status_code, this.filters.http_method, this.filters.path,
			this.filters.only_exceptions);
		this.totalLogs = result.count;
		this.pageLogs = result.rows;
	}

	refreshTable() {
		this.currentPage = 1;
		this.pageLogs = undefined;
		this.updatePage();
	}

	showException(log: any) {
		try {
			this.selectedExceptionStack = undefined;
			this.selectedException = JSON.parse(log.exception);
			if (this.selectedException.stack) {
				this.selectedExceptionStack = this.selectedException.stack;
				delete this.selectedException.stack;
			}
			if (this.selectedException.detail && this.selectedException.detail.StackTrace) {
				this.selectedExceptionSubStack = this.selectedException.detail.StackTrace;
				delete this.selectedException.detail.StackTrace;
			}
		} catch (ex) {
			this.selectedException = log.exception;
		}
		this.modalService.open(this.exceptionModal, { size: "lg" });
	}

	applyFilter(field: string, value: any) {
		this.filters[field] = value;
		this.refreshTable();
	}

	removeFilter(field: string) {
		this.filters[field] = null;
		this.refreshTable();
	}

	ResetFilters() {
		this.filters = {
			only_exceptions: false,
		};
		this.refreshTable();
	}
}
